import { useEffect } from 'react'
import { Box, Text } from '@chakra-ui/react'
import ContractedServiceItem from './ContractedServiceItem'
import { createEmptyContractedService } from '../../../utils/contractedServices'

const ContractedServicesContainerForms = ({ formik }) => {
  const services = formik.values.contracted_services || []

  // Un solo box por cliente: garantizar siempre un registro.
  useEffect(() => {
    if (services.length === 0) {
      formik.setFieldValue('contracted_services', [
        createEmptyContractedService()
      ])
    }
  }, [services.length])

  if (services.length === 0) {
    return (
      <Text fontSize="20px" fontWeight="bold" color="#36355F" pt="50px">
        Servicios contratados
      </Text>
    )
  }

  return (
    <>
      <Text fontSize="20px" fontWeight="bold" color="#36355F" pt="50px">
        Servicios contratados
      </Text>
      <Box marginBlock={4}>
        <ContractedServiceItem index={0} formik={formik} />
      </Box>
    </>
  )
}

export default ContractedServicesContainerForms
